import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StaticHtmlDocumentService } from '../../services/static-html-document.service';
import { HtmlDocumentVersion } from '../../common/htmlDocumentVersion';
import { HtmlDocType } from '../../common/htmlDocType';

@Component({
  selector: 'app-version-view',
  templateUrl: './version-view.component.html',
  styleUrls: ['./version-view.component.scss'],
  standalone: false
})
export class VersionViewComponent implements OnInit {
  version: HtmlDocumentVersion | null = null;
  loading = true;
  error: string | null = null;
  typeLabels: Record<HtmlDocType, string> = { [HtmlDocType.PRIVACY]: 'Datenschutz', [HtmlDocType.AGB]: 'AGB', [HtmlDocType.IMPRESSUM]: 'Impressum' };
  safeContent: SafeHtml | null = null;

  constructor(private route: ActivatedRoute, private router: Router, private sanitizer: DomSanitizer, private documentService: StaticHtmlDocumentService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    let versionIdParam = this.route.snapshot.paramMap.get('versionId');
    if (versionIdParam) {
      let versionId = +versionIdParam;
      this.documentService.getVersionById(versionId).subscribe({
        next: (v) => {
          this.version = v;
          this.safeContent = this.sanitizer.bypassSecurityTrustHtml(v.getHtmlContent() || '');
          this.loading = false;
          this.cd.detectChanges();
        },
        error: (err) => {
          this.error = err?.error?.message || 'Version konnte nicht geladen werden.';
          this.loading = false;
          this.cd.detectChanges();
        }
      });
    } else {
      this.error = 'Version nicht angegeben.';
      this.loading = false;
    }
  }

  back(): void {
    if (this.version?.getDocumentId()) {
      this.router.navigate(['documents', this.version.getDocumentId(), 'versions'], { relativeTo: this.route.parent });
    } else {
      this.router.navigate(['overview'], { relativeTo: this.route.parent });
    }
  }
}
